import { RoomAddedMessageTemplateComponent } from './room-added';
import { RoomAlreadyExistsMessageTemplateComponent } from './room-already-exists';
import { RoomNotFoundMessageTemplateComponent } from './room-not-found';
import { RoomUpdatedMessageTemplateComponent } from './room-updated';

export * from './room-added';
export * from './room-already-exists';
export * from './room-not-found';
export * from './room-updated';


export const RoomMessages = [
    RoomAddedMessageTemplateComponent,
    RoomUpdatedMessageTemplateComponent,
    RoomNotFoundMessageTemplateComponent,
    RoomAlreadyExistsMessageTemplateComponent
];